<template>
  <div class="flex flex-col min-h-full">
    <router-view class="overflow-y-scroll flex-1 scrolling-touch" ref="container" />
    <div class="pt-2 shadow-2xl bg-card flex-shrink-0 xl:hidden" v-if="$store.getters.profile">
      <div class="flex justify-around mx-auto w-full max-w-3xl pb-3">
        <menu-button targetName="Overview" :icon="active === 'Profile' ? 'profile-active' : 'profile'" :label="$t('profile.page-label')" />
        <menu-button targetName="SurveyList" :icon="active === 'Survey' ? 'survey-active' : 'survey'" :label="$t('surveys.page-label')" :number="incompleteSurveys.length" />
        <menu-button targetName="Maps" :icon="active === 'Maps' ? 'maps-active' : 'maps'" :label="$t('maps.page-label')" :number="newMaps.length" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MenuButton from '@/components/MenuButton.vue'

export default {
  components: {
    MenuButton
  },
  computed: {
    ...mapGetters(['userPic']),
    ...mapGetters("surveys", ["newMaps", "incompleteSurveys"]),
    active() {
      switch (this.$route.name) {
        case 'Overview':
        case 'Profile':
          return 'Profile'
          
        case 'Survey':
        case 'SurveyList':
          return 'Survey'
          
        case 'Maps':
        case 'MapsDetail':
          return 'Maps'
          
        default:
          return this.$route.name
      }
    },
  },
  created() {
    this.bindSurveyIndex()
    this.bindSurveys()
  },
  mounted() {
    this.$root.$on('scroll-top', this.scrollToTop)
  },
  beforeDestroy() {
    this.$root.$off('scroll-top', this.scrollToTop)
  },
  methods: {
    scrollToTop() {
      if(this.$refs.container && this.$refs.container.$el) {
        this.$refs.container.$el.scrollTo(0,0)
      }
    },
    ...mapActions('surveys', ['bindSurveyIndex', 'bindSurveys']),
  }
}
</script>

<style>

</style>